module.exports = __webpack_public_path__ + "static/media/loyalty-message-background.52254571.png";